import { FaxService } from '@weave/schema-gen-ts/dist/schemas/fax/v1/fax.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaFaxV1Service = bindHTTP(FaxService);
export const serviceName = 'fax-v1' as const;
